import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=087b9a20&scoped=true&"
import script from "./OwnerList.vue?vue&type=script&lang=js&"
export * from "./OwnerList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerList.vue?vue&type=style&index=0&id=087b9a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b9a20",
  null
  
)

export default component.exports